import React from "react"

function BlogE() {
  return (
    <svg viewBox="0 0 266 150" fill="none">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <path
        d="M39 70.5a1.5 1.5 0 011.5-1.5h46a1.5 1.5 0 010 3h-46a1.5 1.5 0 01-1.5-1.5zM39 76.5a1.5 1.5 0 011.5-1.5h40a1.5 1.5 0 010 3h-40a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <path
        d="M39 58.5a1.5 1.5 0 011.5-1.5h14a1.5 1.5 0 010 3h-14a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--main-500)"
      />
      <path
        d="M39 64.5a1.5 1.5 0 011.5-1.5h32a1.5 1.5 0 010 3h-32a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--solid-900)"
      />
      <path
        d="M20 60a3 3 0 013-3h6a3 3 0 110 6h-6a3 3 0 01-3-3z"
        fill="var(--base-300)"
      />
      <circle cx={44} cy={88} r={5} fill="var(--base-300)" />
      <path
        d="M51 87.5a1.5 1.5 0 011.5-1.5h18a1.5 1.5 0 010 3h-18a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--solid-900)"
      />
      <path
        d="M118 70.5a1.5 1.5 0 011.5-1.5h46a1.5 1.5 0 010 3h-46a1.5 1.5 0 01-1.5-1.5zM118 76.5a1.5 1.5 0 011.5-1.5h40a1.5 1.5 0 010 3h-40a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <path
        d="M118 58.5a1.5 1.5 0 011.5-1.5h14a1.5 1.5 0 010 3h-14a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--main-500)"
      />
      <path
        d="M118 64.5a1.5 1.5 0 011.5-1.5h32a1.5 1.5 0 010 3h-32a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--solid-900)"
      />
      <path
        d="M99 60a3 3 0 013-3h6a3 3 0 110 6h-6a3 3 0 01-3-3z"
        fill="var(--base-300)"
      />
      <circle cx={123} cy={88} r={5} fill="var(--base-300)" />
      <path
        d="M130 87.5a1.5 1.5 0 011.5-1.5h18a1.5 1.5 0 010 3h-18a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--solid-900)"
      />
      <path
        d="M197 70.5a1.5 1.5 0 011.5-1.5h46a1.5 1.5 0 010 3h-46a1.5 1.5 0 01-1.5-1.5zM197 76.5a1.5 1.5 0 011.5-1.5h40a1.5 1.5 0 010 3h-40a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--base-500)"
      />
      <path
        d="M197 58.5a1.5 1.5 0 011.5-1.5h14a1.5 1.5 0 010 3h-14a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--main-500)"
      />
      <path
        d="M197 64.5a1.5 1.5 0 011.5-1.5h32a1.5 1.5 0 010 3h-32a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--solid-900)"
      />
      <path
        d="M178 60a3 3 0 013-3h6a3 3 0 110 6h-6a3 3 0 01-3-3z"
        fill="var(--base-300)"
      />
      <circle cx={202} cy={88} r={5} fill="var(--base-300)" />
      <path
        d="M209 87.5a1.5 1.5 0 011.5-1.5h18a1.5 1.5 0 010 3h-18a1.5 1.5 0 01-1.5-1.5z"
        fill="var(--solid-900)"
      />
    </svg>
  )
}

export default BlogE;
